import { render } from "./payment.vue?vue&type=template&id=6146d35e&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=6146d35e&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6146d35e"]])

export default __exports__